export const en = {
  marketplacePage: {
    title: 'Volunteer Marketplace',
    not_found: 'Not Found',
    description: {
      main: 'Browse ready-to-use volunteer templates, fully virtual and pre-filled with event details.',
      details:
        "Just pick a date, time, and team size to get started.",
    },
    legend: {
      suggested_duration: 'Suggested Duration',
      recommended_capacity: 'Recommended Capacity',
    },
    event_card: {
      virtual_event: 'Virtual Event',
      capacity: '{{min}} - {{max}} People',
      view_template: 'View Template',
    },
    event_preview_modal: {
      banner_alt: 'Banner image for {{name}}',
      use_template: 'Use Template',
      capacity_range: '{{min}}-{{max}} people',
      nonprofit_logo_alt: 'Nonprofit Logo',
      stats: {
        times_partnered: 'TIMES PARTNERED',
        hours_volunteered: 'HOURS VOLUNTEERED',
      },
      sections: {
        about_event: 'About This Event',
        what_youll_do: "What You'll Do",
        your_impact: 'Your Impact',
        about_nonprofit: 'About {{name}}',
      },
      nonprofit: {
        website: 'WEBSITE',
        about: 'ABOUT',
      },
      actions: {
        cancel: 'Cancel',
        use_template: 'Use Template',
      },
    },
  },
}
